export default "__VITE_ASSET__Df1wWIX2__"